export default {
  names: {
    optionTarget: 'option-target',
  },
  option: {
    names: {
      action: 'action',
    },
  },
};
